import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fd09c566"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ds-empty-state" }
const _hoisted_2 = {
  key: 0,
  class: "ds-empty-state__icon"
}
const _hoisted_3 = {
  key: 1,
  class: "ds-empty-state__title"
}
const _hoisted_4 = {
  key: 2,
  class: "ds-empty-state__message"
}
const _hoisted_5 = {
  key: 3,
  class: "ds-empty-state__actions"
}

interface Props {
  title?: string;
  message?: string;
  icon?: string;
  iconSize?: string;
  size?: 'sm' | 'md' | 'lg';
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DSEmptyState',
  props: {
    title: { default: '' },
    message: { default: '' },
    icon: { default: 'inbox' },
    iconSize: { default: '80px' },
    size: { default: 'md' }
  },
  setup(__props: any) {

const props = __props;



void props;

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.icon)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_q_icon, {
            name: _ctx.icon,
            size: _ctx.iconSize
          }, null, 8, ["name", "size"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.title)
      ? (_openBlock(), _createElementBlock("h3", _hoisted_3, _toDisplayString(_ctx.title), 1))
      : _createCommentVNode("", true),
    (_ctx.message)
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.message), 1))
      : _createCommentVNode("", true),
    (_ctx.$slots.default)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "default")
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})